import { Helmet } from "react-helmet-async";
import Hero from "@/web/components/hero";
import TrustStrip from "@/web/components/trust-strip";
import ServicesGrid from "@/web/components/services-grid";
import BrandsStrip from "@/web/components/brands-strip";
import WhyCoolWave from "@/web/components/why-coolwave";
import GoogleReviews from "@/web/components/google-reviews";
import CtaBanner from "@/web/components/cta-banner";

export default function Home() {
  return (
    <>
      <Helmet>
        <title>Cool Wave | Mangawhai Heat Pumps, Air Conditioning & Refrigeration</title>
        <meta
          name="description"
          content="Mangawhai's certified heat pump, air conditioning, refrigeration & home ventilation specialists. For warm, dry, healthy homes."
        />
      </Helmet>
      <Hero />
      <TrustStrip />
      <div className="bg-[linear-gradient(to_bottom,#EAF6FE_0%,#EAF6FE_97%,#FFFFFF_100%)]">
        <ServicesGrid />
        <BrandsStrip />
        <WhyCoolWave />
      </div>
      <GoogleReviews />
      <CtaBanner />
    </>
  );
}
